/* CUSTOM lazy-sticky — Bild/Box schwimmt beim Scrollen sanft (gedämpft) mit und bleibt
   sichtbar, aber immer nur bis zur Unterkante des eigenen Blocks; danach gibt sie den
   Platz frei. Reines Transform (kein Layout-Shift), Desktop ≥990, reduced-motion = hartes
   Sticky ohne Nachlauf. Zielelemente: Produkt-Medienspalte, Coffee-Box, Voucher-Bühne. */
(function () {
  if (window.__lazySticky) return;
  window.__lazySticky = true;

  var SEL = '.coffee-hero__media, .voucher-picker__stage';
  var GAP = 0; // kein Rest-Versatz: Bild sitzt in Ruhelage natürlich, dockt erst beim Scrollen unter dem Header an
  var EASE = 0.12;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var items = [];
  function headerH() {
    var h = document.querySelector('sticky-header, .header-wrapper, header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }
  function collect() {
    items = Array.prototype.map.call(document.querySelectorAll(SEL), function (el) {
      return { el: el, box: el.parentElement, cur: 0 };
    });
  }

  var running = false;
  function loop() {
    var offset = headerH() + GAP;
    var active = window.innerWidth >= 990;
    var keep = false;
    items.forEach(function (it) {
      if (!active) {
        if (it.cur !== 0 || it.el.style.transform) { it.el.style.transform = ''; it.cur = 0; }
        return;
      }
      var room = it.box.offsetHeight - it.el.offsetHeight;
      if (room <= 12) {
        if (it.el.style.transform) { it.el.style.transform = ''; it.cur = 0; }
        return;
      }
      var boxTop = it.box.getBoundingClientRect().top;
      var target = offset - boxTop;
      if (target < 0) target = 0;
      if (target > room) target = room;
      var next = reduce ? target : it.cur + (target - it.cur) * EASE;
      if (Math.abs(target - next) < 0.4) next = target;
      if (Math.abs(next - it.cur) > 0.05) {
        it.cur = next;
        it.el.style.transform = 'translateY(' + next.toFixed(1) + 'px)';
      }
      if (next !== target) keep = true;
    });
    running = keep;
    if (keep) requestAnimationFrame(loop);
  }
  function kick() { if (!running) { running = true; requestAnimationFrame(loop); } }

  function init() {
    collect();
    kick();
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', function () { collect(); kick(); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
